import CloseSvg from "../../icons/CloseSvg";
import Button from "../baseComponents/Button/Button";
import {useDispatch, useSelector} from "react-redux";
import mapStateToProps from "./mapStateToProps";
import {setShowBurgerMenu} from "../../actions/ui";
import {BURGER_MENU_LIST} from "./constants";
import useStyles from "./useStyles";

/* закрывает любое открытое бургер меню */
/* открывает главное меню */
export const BurgerMenusToggler = () => {

    const {
        burgerMenuOpened
    } = useSelector(mapStateToProps)

    const classes = useStyles();
    const dispatch = useDispatch()

    const togglePopupHandler = () => {

        // если хоть одно меню открыто, все обнуляем !!!
        if (burgerMenuOpened?.name) {
            dispatch(setShowBurgerMenu(null))
        } else {
            // иначе открываем моб меню определенного вида (имени) !!!
            dispatch(setShowBurgerMenu({
                name: BURGER_MENU_LIST.MAIN_MENU
            }))
        }
    };

    return (
        <Button className={classes.containerBurger} onClick={togglePopupHandler}>

            { burgerMenuOpened?.name ? <CloseSvg height={20} width={20}/> : (
                <>
                    <div className={classes.lineBurger}></div>
                    <div className={classes.lineBurger}></div>
                    <div className={classes.lineBurger}></div>
                </>
            )}

        </Button>
    )
}